import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { MQ } from './teacherTokens';

/**
 * `.stat` — icon chip, large number, label, optional muted subtitle.
 *
 * `tone` maps to the mockup's `.stat .ic` modifiers: default (primary tint),
 * `ok` (`--ok-soft`), `bad` (`--bad-soft`). Presentation only; every value is
 * supplied by the page.
 */
const TeacherStatCard = ({ label, value, icon, subtitle, tone = 'primary', onClick, sx = {} }) => {
  const paletteKey = tone === 'ok' ? 'success' : tone === 'bad' ? 'error' : tone === 'warn' ? 'warning' : 'primary';

  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '18px',
        padding: '18px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        height: '100%',
        transition: '.18s',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': {
          boxShadow: '0 10px 24px -16px rgba(17,26,46,.4)',
          borderColor: (t) => alpha(t.palette.text.primary, 0.18),
        },
        ...sx,
      }}
    >
      {icon && (
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '12px',
            display: 'grid',
            placeItems: 'center',
            color: `${paletteKey}.main`,
            bgcolor: (t) => alpha(t.palette[paletteKey].main, 0.13),
            '& svg': { fontSize: 18 },
          }}
        >
          {icon}
        </Box>
      )}
      <Box>
        <Typography
          sx={{
            fontSize: 28,
            fontWeight: 800,
            lineHeight: 1,
            color: 'text.primary',
            [MQ.phoneSm]: { fontSize: 24 },
          }}
        >
          {value}
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: '13.5px', color: 'text.primary', mt: '2px' }}>
          {label}
        </Typography>
      </Box>
      {subtitle && (
        <Typography sx={{ fontSize: '12.5px', color: 'text.secondary' }}>{subtitle}</Typography>
      )}
    </Box>
  );
};

export default TeacherStatCard;
